module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAABCAYAAAAGu30GAAAAI0lEQVR4AWN4//Frw2DC7zZtm0RtPIpH8SgexaN4FA+2+g4ARuKR9FxXlf0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grids/landing_maincontainer+margin.png
// module id = 347
// module chunks = 0